import $ from 'jquery'
import Swiper from '@/swiper-bundle'
import { Navigation } from 'swiper/modules'
import 'swiper/less/navigation'

export const initializeSwiperSuiteVariations = () =>
  $('.prod-suite-variations .swiper-slide').length
    ? new Swiper('.prod-suite-variations .swiper', {
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    : null
